/**
 * Browser/platform facts captured with every report, all snake_case to match
 * the server-stamped keys (`api_timestamp`, `api_github_sha`,
 * `api_environment`) the API adds on top — one naming convention for the
 * whole stored `client` block. All values are read at submit time. There is
 * no frontend build SHA to include — the app exposes none
 * (`app/package.json` is `0.0.0`, no VITE injection); the server-stamped
 * deploy SHA identifies the running release instead.
 */
export function collectClientInfo(): Record<string, unknown> {
  return {
    user_agent: navigator.userAgent,
    platform: navigator.platform,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: navigator.language,
    timestamp: new Date().toISOString()
  };
}
